import NPFilterBar from './np-filter-bar.vue';
import NPFilterWidget from './np-filter-widget.vue';
import NPPagination from './np-pagination.vue';

NPFilterWidget.install = function install (Vue) {
    Vue.component(NPFilterBar.name, NPFilterBar);
    Vue.component(NPFilterWidget.name, NPFilterWidget);
    Vue.component(NPPagination.name, NPPagination);
}

export default NPFilterWidget;